import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { ActionListItem, ActionListFileTrigger } = designSystem;

const defaultFileTriggerConfig = {};

function ContextMenuItem({
  caption,
  glyph = null,
  contentRight = null,
  onClick = Function.prototype,
  onMouseEnter = Function.prototype,
  onMouseLeave = Function.prototype,
  onMouseDown = Function.prototype,
  id = null,
  element = null,
  beforeItemClick = Function.prototype,
  active = false,
  disabled = false,
  fileTriggerConfig = defaultFileTriggerConfig,
  iconPlacement = '',
  iconType = '',
  withBetaLabel = false,
}) {
  const handleMouseEnter = useCallback(
    (e) => {
      if (!disabled) {
        onMouseEnter(e);
      }
    },
    [onMouseEnter, disabled]
  );

  const handleClick = useCallback(
    (e) => {
      if (!disabled) {
        beforeItemClick({ id, element });
        onClick(e);
      }
    },
    [beforeItemClick, onClick, id, element, disabled]
  );

  const handleMouseDown = useCallback(
    (e) => {
      if (!disabled) {
        onMouseDown(e);
      }
    },
    [onMouseDown, disabled]
  );

  return Object.keys(fileTriggerConfig).length ? (
    <ActionListFileTrigger
      title={caption}
      iconGlyph={glyph}
      disabled={disabled}
      onClick={handleClick}
      selected={active}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={onMouseLeave}
      fileTriggerConfig={fileTriggerConfig}
    />
  ) : (
    <ActionListItem
      title={caption}
      iconGlyph={glyph}
      contentRight={contentRight}
      disabled={disabled}
      onClick={handleClick}
      selected={active}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={handleMouseDown}
      {...(iconPlacement && { iconPlacement })}
      {...(iconType && { iconType })}
      {...(withBetaLabel && { withBetaLabel })}
    />
  );
}

ContextMenuItem.propTypes = {
  id: PropTypes.string,
  caption: PropTypes.string.isRequired,
  element: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.object]),
  contentRight: PropTypes.elementType,
  glyph: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseDown: PropTypes.func,
  beforeItemClick: PropTypes.func,
  active: PropTypes.bool,
  fileTriggerConfig: PropTypes.shape(),
  iconPlacement: PropTypes.string,
  iconType: PropTypes.string,
  withBetaLabel: PropTypes.bool,
};

export default ContextMenuItem;
